<template>
  <div class="userBox">
    <el-popover
        :width="280"
        popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
    >
      <template #reference>
        <div class="userImg headerUserAvatar">
          <img src="./img/user.png">
        </div>
      </template>
      <template #default>
        <div class="poUser">
          <div class="content">
            <div class="userCenterWrap">
              <div class="userBox2">
                <div class="userImg">
                  <img src="./img/user.png">
                </div>
              </div>
              <div class="userName">{{userInfo&&userInfo.employeeName?userInfo.employeeName:'--'}}</div>
            </div>

          </div>
          <div class="account">
            <div>{{ $t('user.account') }}</div>
            <div class="text">{{userInfo&&userInfo.phone?userInfo.phone:'--'}}</div>
            <div>{{ $t('user.company') }}</div>
            <div class="text">{{userInfo&&userInfo.company?userInfo.company:'--'}}</div>
          </div>
          <div class="cell" @click="updatePwd">
            <span class="icon sw-iconfont cellIcon">&#xe65e;</span>
            <span>{{ $t('user.updatePassword') }}</span>
          </div>
          <div class="cell" @click="logout">
            <span class="icon sw-iconfont cellIcon">&#xe677;</span>
            <span>{{ $t('user.logout') }}</span>
          </div>
        </div>
      </template>
    </el-popover>
    <el-dialog
        v-model="dialogVisible"
        title=""
        width="30%">
            <span class="logoutText">
                <span class="icon sw-iconfont logoutIcon">&#xe66f;</span>{{ $t('user.logoutConfirm') }}
            </span>
      <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">{{ $t('common.buttons.cancel') }}</el-button>
                    <el-button type="primary" @click="confirmLogout">{{ $t('common.buttons.confirm') }}</el-button>
                </span>
      </template>
    </el-dialog>
    <el-dialog
        v-model="updatePwdVisible"
        :title="$t('user.updatePasswordTitle')"
        width="30%">
      <el-form class="userFrom" ref="ruleFormRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item class="pwd" :label="$t('common.labels.oldPassword')" prop="oldPassword">
          <el-input v-model="form.oldPassword" type="password" :placeholder="$t('user.oldPasswordPlaceholder')" show-password></el-input>
        </el-form-item>
        <el-form-item class="pwd" :label="$t('common.labels.newPassword')" prop="password">
          <el-input v-model="form.password" type="password" :placeholder="$t('user.newPasswordPlaceholder')" show-password></el-input>
        </el-form-item>
        <el-form-item class="confirmpwd" :label="$t('common.labels.confirmPassword')" prop="confirmpwd">
          <el-input v-model="form.confirmpwd" type="password" :placeholder="$t('user.confirmPasswordPlaceholder')" show-password>
          </el-input>
        </el-form-item>
      </el-form>

      <template #footer>
                <span class="dialog-footer">
                    <el-button @click="updatePwdVisible = false">{{ $t('common.buttons.cancel') }}</el-button>
                    <el-button type="primary" @click="confirmUpdate(ruleFormRef)">{{ $t('common.buttons.confirm') }}</el-button>
                </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
  import {md5} from 'js-md5';
  import {FormInstance} from 'element-plus';
  import { ElMessage } from 'element-plus'
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const dialogVisible = ref(false);
  const updatePwdVisible = ref(false);
  const router = useRouter();

  const ruleFormRef = ref<FormInstance>();


  const form = reactive({
    oldPassword: "",
    password: "",
    confirmpwd: ""
  });

  const userInfo= ref();

  // 检验规则
  const validatePassword = (rule: any, value: any, callback: any) => {
    if (!value) {
      return callback(new Error(t('user.validation.passwordRequired')));
    }
    if (value.length < 6) {
      callback(new Error(t('user.validation.passwordMinLength')));
    } else {
      if (value.length > 32) {
        callback(new Error(t('user.validation.passwordMaxLength')));
      } else {
        callback();
      }
    }
  };
  const validateConfirmpwd = (rule: any, value: any, callback: any) => {
    if (!value) {
      return callback(new Error(t('user.validation.passwordRequired')));
    }
    console.log(form);
    if (value.length < 6) {
      callback(new Error(t('user.validation.passwordMinLength')));
    } else {
      if (value.length > 32) {
        callback(new Error(t('user.validation.passwordMaxLength')));
      } else {
        if (!form.password || form.password !== '') {
          if (form.password !== value) {
            callback(new Error(t('user.validation.passwordNotMatch')));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    }
  };
  const rules = reactive({
    oldPassword: [{
      required: true, validator: validatePassword, trigger: 'blur'
    }],
    password: [{
      required: true, validator: validatePassword, trigger: 'blur'
    }],
    confirmpwd: [{
      required: true, validator: validateConfirmpwd, trigger: 'blur'
    }]
  });

  const updatePwd = async () => {
    updatePwdVisible.value = true;
  };
  const logout = async () => {
    dialogVisible.value = true;
  };
  const confirmLogout = async () => {
    const {fail} = await aServe.submitLogout({
      sessionKey: localStorage.sessionId,
    });
    if (!fail) {
      router.push({
        path: '/login'
      });
      aStore.remove('sessionId');
      aStore.remove('userInfo');
    }
  };
  const confirmUpdate = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    formEl.validate(async (valid: any) => {
      if (valid) {
        if (form.password !== form.confirmpwd) {
          ElMessage({
            message: t('user.passwordNotMatch'),
            type: 'error'
          })
          return
        }
        const {fail} = await aServe.postAccUpdatePwd({
          type: 0, // 旧密码密码验证
          // employeeId: userInfo.value.employeeId,
          // accPwd:  md5(form.password),
          oldPwd: md5(form.oldPassword),
          newPwd: md5(form.password),
        });
        if (!fail) {
          ElMessage.success(t('user.updateSuccess'))
          updatePwdVisible.value = false;
        }
      }
    });
  };


  onMounted(()=>{
    userInfo.value =  aStore.get('userInfo')||{};
  })
</script>

<style lang="scss" scoped>
  .pwd {
    margin-bottom: 20px;
  }

  .logoutIcon {
    margin-right: 5px;
    color: var(--color-warning);
    font-size: 20px;
  }

  .logoutText {
    font-size: 20px;
  }

  .userBox {
    border: 2px solid var(--btn-disabled-color);
    border-radius: 30px;
  }

  .poUser {
    width: 100%;

    .content {
      display: flex;
      justify-content: center;

      .userCenterWrap {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .userBox2 {
        width: 44px;
        height: 44px;
        border: 2px solid #C3C2C4;
        border-radius: 30px;
      }
    }

    .userName {
      color: #000000;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .account {
      padding: 10px;
      background: #F1F2F4;
      border-radius: 10px;
      margin-bottom: 4px;

      div {
        height: 25px;
        line-height: 25px;
      }

      .text {
        margin-bottom: 5px;
        color: #000;
      }
    }

    .cell {
      color: #000000;
      height: 50px;
      line-height: 50px;
      padding-left: 10px;
      border-bottom: 1px solid #E9E9EB;
      cursor: pointer;
      &:hover {
        background-color: #F1F2F4;
      }

      .cellIcon {
        margin-right: 5px;
      }
    }

    .cell:last-child {
      border-bottom: none;
    }
  }
  .headerUserAvatar {
    width: 36px;
    height: 36px;
    border-radius: 36px;
    overflow: hidden;
    img {
      width: 36px;
      height: 36px;
    }
  }
</style>
